// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import { Changeset } from '@fulcrumapp/fulcrum-core';
import MetadataField from './metadata-field';

export default class ChangesetField extends MetadataField {
  static propTypes = {
    ...MetadataField.propTypes,
    changeset: PropTypes.instanceOf(Changeset),
  };

  renderLabelContent() {
    return (
      <span>
        <strong className={MetadataField.styles.strong}>Source</strong>
      </span>
    );
  }

  renderValueContent() {
    return <span>{this.valueString}</span>;
  }

  get valueString() {
    if (this.props.changeset) {
      return this.props.changeset.metadataDescription;
    }

    return 'N/A';
  }
}

const styles = cssInJS({
});

ChangesetField.styles = styles;
